import React, { Component } from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { fetchParentControls } from '../actions';
import { Link } from 'react-router-dom';
import { PATH_PARENT, PC_STATE_ON, PATH_PROFILES } from '../constants';
import Isvg from 'react-inlinesvg';
import lock from '../img/icons/lock.svg';
import lock_open from '../img/icons/lock_open.svg';
import warning from '../img/icons/warning.svg';

class ProgrammeWarning extends Component {
  componentDidMount = () => {
    if (this.props.auth) {
      this.props.fetchParentControls();
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {};
  render() {
    const { prog, strings, parentControlState, isChildLocked } = this.props;
    let icon = parentControlState === PC_STATE_ON ? lock : lock_open;
    let status = parentControlState === PC_STATE_ON ? strings.on : strings.off;

    if (prog.content_warnings && prog.content_warnings.length > 0) {
      return (
        <div className="programme__warning">
          <div className="programme__warning-inner">
            <div className="programme__warning-title-container">
              <Isvg className="icon" src={warning} />
              <h3 className="programme__warning-title">
                {strings.contentWarning}
              </h3>
            </div>
            {isChildLocked && (
              <>
                <p>{strings.contentUnsuitableForChildren}</p>
                <p>
                  <Link className="parent-control__link" to={PATH_PROFILES}>
                    {strings.manageProfiles}
                  </Link>
                </p>
              </>
            )}
            {!isChildLocked && (
              <>
                <ul className="programme__warning-list">
                  {prog.content_warnings &&
                    prog.content_warnings.length > 0 &&
                    Object.keys(prog.content_warnings).map((key) => {
                      return (
                        <li key={key} className="programme__warning-item">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: prog.content_warnings[key].warning_text,
                            }}
                          />
                        </li>
                      );
                    })}
                </ul>

                <div className="programme__parent-control">
                  {icon && <Isvg className="icon" src={icon} />}
                  <Link className="parent-control__link" to={PATH_PARENT}>
                    {strings.parentControlSettings}
                    {status && status !== '' && ': ' + status}
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth.authenticated,
    parentControlState: state.parentControlState,
  };
}
export default translate(
  connect(mapStateToProps, { fetchParentControls })(ProgrammeWarning)
);
